import { filestack as config } from '../config';
import * as filestack from 'filestack-js';

export const FileStackClient = filestack.init(config.apiKey);

export function getFilePath(id) {

  return `https://www.filestackapi.com/api/file/${id}`
}

export function getCdnFilePath(id) {

  return `https://cdn.filepicker.io/api/file/${id}`
}

export function getImagePreviewUrl(url, width = 1024, height = 768) {
  const options = `resize=width:${width},height:${height},fit:crop`;

  return `https://process.filestackapi.com/${config.apiKey}/${options}/${url}`;
}

export function getFilePreviewUrl(url, width = 1024, height = 768, density = 200) {
  const options = `output=format:jpg,density:${density}/resize=width:${width},height:${height},fit:crop`;

  return `https://process.filestackapi.com/${config.apiKey}/${options}/${url}`
}

export function getFilePreviewUrlFullSize(url, width = 1024, height = 768, density = 200) {
  const options = `output=format:jpg,density:${density}/resize=width:${width},height:${height},fit:clip`;

  return `https://process.filestackapi.com/${config.apiKey}/${options}/${url}`
}

export function getFileMetaData(fileId) {
  return fetch(`${getFilePath(fileId)}/metadata`, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => response.json());
}

export function getZipDownloadUrl(arrayOfFiles) {
  if(arrayOfFiles.length === 0){
    return;
  }

  return `https://process.filestackapi.com/zip/${JSON.stringify(arrayOfFiles)}`
}
